export default {
    en: {
        'welcome-title': "Welcome to ecuidHaMUs project",
        'welcome-title2': "Welcome",
        'welcome-first-paragraph': "The e.cuidHaMUs Project (Sustainable integrated health monitoring system at the University of Aveiro) is led by a multidisciplinary group of professors from the University of Aveiro, belonging to the School of Health (ESSUA), Department of Mathematics (DM) and Department of Communication and Art (DECA).",
        'welcome-second-paragraph': "The project allows to obtain four results:",
        'welcome-li-one': "Web application for recording and viewing clinical health data",
        'welcome-li-two': "Web application for registration and monitoring of clinical data ",
        'welcome-li-three': "Scientific Disclosure in Specialty Magazines",
        'welcome-li-four': "Platform usage guide.",
        'support-title': "Support",
        'support-text': "The Office of Occupational Medicine at the University of Aveiro in the processes of collection, storage, creation and distribution of information",
        'contribute-title': "Contribute",
        'contribute-text': "Contribute to the epidemiological monitoring and surveillance of the health of UA workers by researchers",
        'assist-title': "Assist",
        'assist-text': "The user (worker of the UA) in the fast and easy access to its clinical history, to the scheduling and request of appointments, among others.",
        'login': "Sign in",
        'register': "Sign up",
        'register-code': "Register code",
        'see-code': "Consult codes",
        'forgot-password': "Did you forgot your password?",
        'login-button': "Sign in",
        'login-register-message': "No account?",
        'login-register-message-link': "Sign up",
        'ua-email-only': "*only UA email allowed",
        'pw-error': "password should have 6 characters or more",
        'confirm-pw': "Confirm password",
        'confirm-pw-error': "Passwords don't match",
        'accept-terms': "I accept the",
        'accept-terms-link': "terms and services",
        'register-button': "Sign up",
        'copyright-text': "Copyright © e.cuidHaMUs",
        'recover-password': "Recover password",
        'recover-password-help': "Insert your email to recover your password",
        'recover-button': "Recover",
        'insert-code-title': "Insert your e.code",
        'insert-code-btn': "Insert",
        'consult-code-title': "Consult your e.codes",
        'socio-demographic': "Socio-Demographic Data",
        'smoking-health': "Smoking and Health Habits",
        'diseases-pain': "Diseases and Pain",
        'eating-habits': "Eating Habits",
        'physical-exercise': "Physical Exercise",
        'diagnostic-exams': "Diagnostic Exams",
        'physiological-data': "Physiological Data",
        'gender': "Gender:",
        'department': "Department/School/Service:",
        'age': "Age:",
        'marital-status': "Marital Status:",
        'academic': "Academic Qualifications:",
        'smoker-status': "Current Situation:",
        'regularity': "Regularity:",
        'average-number': "Average number per week:",
        'health-opinion': "Generally you would say that your health is:",
        'weight': "Weight:",
        'height': "Height:",
        'has-disease': "Do you have any chronic illness?",
        'chronic-diseases': "If so, indicate which:",
        'take-meds': "Do you regularly take any medication?",
        'meds-number': "If so, indicate the number of medication you take per week:",
        'meds-name': "If so, indicate which:",
        'pain': "Rate your pain:",
        'pain-local': "Indicate where the pain is higher:",
        'pain-scale': "Rate the average pain intensity:",
        'meals': "On average, how many meals do you eat daily:",
        'breakfast': "On average, how often do you eat breakfast per week:",
        'fruit': "On average, how often do you eat fruit per week:",
        'vegetables': "On average, how often do you eat vegetables per week:",
        'sodas': "On average, how often do you drink soft drinks per week:",
        'fast-food': "On average, how often do you eat fast food per week:",
        'alcohol': "On average, what's the amount of alcohol you consume per week:",
        'practice-physical': "Do you practice programmed sport/physical exercise?",
        'physical-name': "If so, which:",
        'physical-hours': "On average, how many hours per week?",
        'walking-cycling': "Each day, how many minutes do you usually walk or bike (to and from work, school, or shopping)",
        'cardiac-cycle': "Cardiac Cycle",
        'systolic': "Systolic blood pressure:",
        'diastolic': "Diastolic blood pressure:",
        'pulse': "Pulse:",
        'biochemistry': "Biochemistry",
        'uric-acid': "Uric acid:",
        'glucose': "Glucose:",
        'cholestrol': "Total Cholestrol:",
        'spirometry': "Spirometry:",
        'visual_screening': "Visual Screening:",
        'auditory_screening': "Auditory Screening:",
        'ecg': "ECG:",
        'erythrogram': "Erythrogram:",
        'leukogram': "Leukogram",
        'normal': "Normal",
        'changed': "Changed",
        'change': "Change:",
        'nocode-title': "No registered codes",
        'nocode-btn': "Insert e.code",
        'participate': "Join now!",
        'indicators': "Indicators",
        'geral-indicators': "General Indicators",
        'department-indicators': "Department Indicators",
        'gender2': "Gender",
        'age2': "Age",
        'marital2': "Marital Status",
        'academic2': "Academic Levels",
        'smoker-status2': "Current smoker situation",
        'regularity2': "Regularity",
        'average-number2': "Average number per week",
        'health-opinion2': "Health Opinions",
        'beers': "Number of beers:",
        'spirit_drinks': "Number of spirit drinks:",
        'wine': "Number of wine glasses:",
        'weight2': "Weight",
        'height2': "Height",
        'personal_indicators': "Personal Indicators",
        'has-disease2': "Do you have any chronic illness?",
        'take-meds2': "Do you regularly take any medication?",
        'pain2': "Pain rate",
        'pain-scale2': "Average pain intensity",
        'meals2': "Daily meals",
        'breakfast2': "Breakfast per week",
        'fruit2': "Fruit per week",
        'vegetables2': "Vegetables per week",
        'sodas2': "Soft drinks per week",
        'fast-food2': "Fast food per week",
        'practice-physical2': "Do you practice programmed sport/physical exercise?",
        'physical-hours2': "On average, how many hours per week?",
        'walking-cycling2': "Each day, how many minutes do you usually walk or bike",
        'choose-department': "Choose a department",
        'systolic2': "Systolic blood pressure",
        'diastolic2': "Diastolic blood pressure",
        'pulse2': "Pulse",
        'uric-acid2': "Uric acid",
        'glucose2': "Glucose",
        'cholesterol2': "Total Cholestrol",
        'respondents': "Total of responses:",
        'registered-people': "Registered people",
        'completed-questionnaires': "Completed questionnaires",
        'registered-questionnaires': "Registered questionnaires",
        'delete': "Delete",
        'cancel': "Cancel",
        'delete-code': "Delete code",
        'delete-message': "Are you sure you want to delete this code? Only the association of the code with the user is eliminated, the data related to this code is kept for statistical purposes",
        'all-departments': "All departments",
        'all-years': "All years",
        'yes': "Yes",
        'no': "No",
        'not-answer': "Did not answer",
        'not-filled': "Not filled",
        'not-consume': "Does not consume",
        'pie-chart': "Pie Chart (relative frequency)",
        'bar-chart': "Bar Chart (absolute frequency)",
        'chronic-diseases2': "Chronic diseases",
        'meds-number2': "Number of meds",
        'meds': "Meds",
        'local-pain': "Where the pain is highest",
        'beers2': "Number of beers (33cl)",
        'spirit_drinks2': "Number of spirit drinks (12cl)",
        'wine2': "Number of wine glasses (20cl)",
        'alcohol2': "Consume alcohol",
        'spirometry2': "Spirometry",
        'visual_screening2': "Visual Screening",
        'auditory_screening2': "Auditory Screening",
        'ecg2': "ECG",
        'erythrogram2': "Erythrogram",
        'leukogram2': "Leukogram",
        'spirometry-change': "Spirometry change",
        'visual_screening-change': "Visual Screening change",
        'auditory_screening-change': "Auditory Screening change",
        'ecg-change': "ECG change",
        'erythrogram-change': "Erythrogram change",
        'leukogram-change': "Leukogram change",
        'by-gender': "By gender",
        'by-ages': "By ages",
        'first-name': "First name",
        'last-name': "Last name",
        'profile': "Profile",
        'update-profile': "Update profile",
        'account': "Account",
        'change-password': "Change password",
        'delete-account': "Delete account",
        'delete-account-warning': "Once you delete your account, there is no going back. Any codes you have associated with this account will be deleted!",
        'current-password': "Current password",
        'new-password': "New password",
        'confirm-new-password': "Confirm new password",
        'personal-area': "Personal area",
        'delete-account-1': 'Are you sure you want to delete your account?',
        'delete-account-2': 'Any codes that you have associated with this account will be deleted.',
        'delete-account-3': 'If you want to delete your account, enter your password and click in the delete account button, otherwise click the cancel button.',
        'edit-button': 'Edit',
        'edit-form': 'Edit form',
        'edit-form-text': 'All questions on the form that you did not answer on the day of the consultation are listed below so you can answer now. After you answer and edit the form you will not be able to re-edit the questions you have answered now.',
        'edit-modal-text': 'Are you sure you want to edit the form? After editing you will not have another opportunity to edit the questions you have answered.',
        'no-answer': 'Do not answer',
        'smoker-status-edit': "Smoking situation:",
        'regularity-edit': "Regularity with which you smoke:",
        'average-number-edit': "Average number of cigarettes per week:",
        'chronic-diseases-edit': "Indicate which chronic diseases you have:",
        'meds-number-edit': "Indicate the number of different meds you take per day:",
        'meds-name-edit': "Indicate which meds you take:",
        'physical-name-edit': "Which sports do you practice:",
        'physical-hours-edit': "How many hours per week do you practice physical exercise:",
        'alcohol-edit': "Do you consume alcohol on a weekly basis?",
        'legends-tooltip': "*click on the graphics labels to hide or show the values",
        'since': "Since",
        'until': "Until",
        'completed': "Completed",
        'not-completed': "To complete",
        'histogram': "Histogram",
        'terms' : "Terms",
        'amount' : "Amount:",
        'sleep-opinion' : "Sleep quality",
        'sleep-hours' : "How many hours you sleep per day",
        'admin': "ADMINISTRATION",
        'home': "HOME",
        'studies': "STUDIES VISUALIZATION",
        'user': "USER",
        'others': "Others",
        'studieParticipation': "STUDIES PARTICIPATION",
        'usability': "Usability",
        'privateArea': "PRIVATE AREA",
        'studie2': "Studie2",
        'suggestions': "Suggestions",
        'researcher': "Researcher",
        'makers': "Makers",
        'configs': "Configurations",
        'permissions': "Permissions Management",
        'admin2': "Administration"

    }
}



// WEBPACK FOOTER //
// ./src/languages/language_en.js